module.exports = __webpack_public_path__ + "static/media/hualian_pic5.824d195d.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/hualian_pic5.jpg
 ** module id = 448
 ** module chunks = 0
 **/